import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import { withMotion } from "app/hooks/withMotion";
import { Outlet } from "react-router-dom";

const InventoryPresenter = () => {
  return (
    <Layout className="sub-layout-protected">
      <Content>
        <Outlet />
      </Content>
    </Layout>
  );
};

export default withMotion(InventoryPresenter);
